module.exports = __webpack_public_path__ + "img/20190723144028680.46a82cad.png";